import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBodyType } from '../thunks/vehicleThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearVehicleKey } from '../thunkKeys/commonThunksKeys';

const SLICE_NAME = 'bodyType';

export const bodyTypeSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearBodyType(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBodyType });
        builder.addCase(
            clearVehicleKey,
            () => commonInitialState,
        );
    },
});

export const { clearBodyType } = bodyTypeSlice.actions;

export const bodyType = bodyTypeSlice.reducer;
